// Admin shell / dashboard placeholder for Phase 1.
// Real admin CRUD is built in later phases per approved scope.

import React from 'react';
import { AdminGate } from '../components/AdminGate';
import { AppShell } from '../components/AppShell';
import { BrandButton } from '../components/BrandButton';
import { supabase } from '../lib/supabase';
import { useSession } from '../lib/useSession';

export default function AdminDashboard() {
  const { user } = useSession();
  return (
    <AdminGate>
      <AppShell>
        <div className="flex items-baseline justify-between flex-wrap gap-4">
          <div>
            <div className="eyebrow" data-testid="admin-eyebrow">Admin</div>
            <h1 className="h1 mt-2" data-testid="admin-title">Dashboard</h1>
            <p className="mt-2" style={{ color: 'var(--text-dim)' }}>
              Signed in as {user?.email || user?.phone || user?.id}
            </p>
          </div>
          <BrandButton
            variant="outline"
            size="sm"
            onClick={() => supabase?.auth?.signOut()}
            data-testid="admin-signout-btn"
          >
            Sign out
          </BrandButton>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
          {[
            'Paid today',
            'Awaiting prep',
            'Ready for pickup',
            'Picked up today',
          ].map((t) => (
            <div key={t} className="surface p-5" data-testid={`admin-tile-${t.replace(/\s+/g, '-').toLowerCase()}`}>
              <div className="eyebrow">{t}</div>
              <div className="font-display text-5xl mt-3">—</div>
            </div>
          ))}
        </div>

        <div className="surface p-6 mt-8">
          <div className="eyebrow">Coming in later phases</div>
          <ul
            className="mt-4 space-y-2"
            style={{ color: 'var(--text-dim)' }}
          >
            <li>Meals · Add / Edit · Allergens · Square Mapping</li>
            <li>Customers · Plans · Trainer Codes</li>
            <li>Orders · Pickup Windows · Planner Rules</li>
          </ul>
        </div>
      </AppShell>
    </AdminGate>
  );
}
